var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 14,
    fill: "#bc63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.531,44.942l-0.182,-0.015c-1.654,-0.125 -3.365,-0.485 -5,-1.061l0.664,-1.887c1.471,0.518 3.011,0.842 4.578,0.964zM27.665,44.666l-0.363,-1.967c1.54,-0.285 3.041,-0.775 4.461,-1.455l0.865,1.803c-1.579,0.757 -3.249,1.302 -4.963,1.619zM12.695,41.502c-1.438,-0.987 -2.745,-2.16 -3.883,-3.488l1.52,-1.301c1.023,1.195 2.199,2.252 3.494,3.141zM37,40.199l-1.301,-1.52c1.196,-1.023 2.254,-2.198 3.144,-3.492l1.648,1.133c-0.988,1.438 -2.163,2.742 -3.491,3.879zM5.961,33.646c-0.758,-1.577 -1.304,-3.247 -1.624,-4.962l1.967,-0.366c0.287,1.542 0.778,3.043 1.46,4.461zM42.861,31.669l-1.887,-0.664c0.521,-1.478 0.847,-3.024 0.97,-4.597l1.003,0.005l0.997,0.08l-0.006,0.075c-0.136,1.743 -0.499,3.46 -1.077,5.101zM6.056,23.592l-1.997,-0.122l0.004,-0.04c0.135,-1.731 0.493,-3.437 1.064,-5.064l1.887,0.662c-0.513,1.465 -0.836,3 -0.958,4.564zM41.69,21.649c-0.292,-1.543 -0.786,-3.043 -1.47,-4.458l1.801,-0.87c0.76,1.574 1.31,3.242 1.634,4.958zM9.138,14.84l-1.65,-1.13c0.985,-1.438 2.157,-2.746 3.484,-3.885l1.303,1.518c-1.196,1.025 -2.251,2.202 -3.137,3.497zM37.646,13.261c-1.027,-1.194 -2.205,-2.248 -3.501,-3.134l1.129,-1.651c1.439,0.984 2.747,2.155 3.888,3.48zM16.205,8.772l-0.867,-1.802c1.575,-0.759 3.243,-1.307 4.958,-1.628l0.369,1.966c-1.542,0.289 -3.043,0.782 -4.46,1.464zM29.955,8.008c-1.461,-0.511 -2.99,-0.831 -4.547,-0.953l0.023,-1.001l0.079,-0.997l-0.079,0.997l0.11,-0.995c1.75,0.137 3.45,0.494 5.073,1.061z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 18.5,
    r: 4.5,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 9.5,
    r: 4.5,
    fill: "#bc63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,33h-5v-9h1v8h4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.504,32.969c-1.591,0 -2.504,-0.932 -2.504,-2.556v-4.413h1v4.413c0,1.076 0.464,1.556 1.504,1.556c1.124,0 2.496,-0.844 2.496,-1.829v-4.14h1v4.14c0,1.593 -1.879,2.829 -3.496,2.829z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,33h-1v-5.005c0,-0.992 -0.525,-1.495 -1.562,-1.495c-0.66,0 -1.643,0.274 -1.643,1.03h-1c0,-1.333 1.329,-2.03 2.643,-2.03c1.581,0 2.562,0.956 2.562,2.495z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 30,
    width: 1,
    height: 3,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.755,33.053c-1.285,0 -2.255,-0.99 -2.255,-2.303c0,-1.537 1.625,-2.012 2.932,-2.395c0.673,-0.197 1.368,-0.4 1.648,-0.685l0.713,0.701c-0.463,0.47 -1.249,0.7 -2.081,0.943c-1.336,0.391 -2.212,0.702 -2.212,1.435c0,0.755 0.527,1.303 1.255,1.303c1.059,0 1.765,-0.369 2.291,-1.196l0.844,0.536c-0.71,1.118 -1.736,1.661 -3.135,1.661z",
    fill: "#ffffff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuaIcon);
export default __webpack_public_path__ + "static/media/luaIcon.a8d0c96eb98370cd56f1158ed7aa43eb.svg";
export { ForwardRef as ReactComponent };